import { useState, useEffect } from 'react';
import { useErrorReporter } from '@wix/cli-error-reporting';
import { createVeloCLIServer } from '@wix/editor-velo-cli-comm-api';
import type { DocumentFSUpdate } from '@wix/editor-velo-cli-comm-api';
import { CliError, CliErrorCode } from '@wix/cli-error';

export function useWebSocketServer() {
  const { reportError } = useErrorReporter();
  const [server] = useState(() => {
    const instance = createVeloCLIServer();

    return {
      ...instance,
      async syncDocumentUpdate(document: DocumentFSUpdate) {
        try {
          return await instance.syncDocumentUpdate(document);
        } catch (error) {
          throw new CliError({
            code: CliErrorCode.FailedToSyncVeloCLIServerDocumentUpdate(),
            cause: error,
          });
        }
      },
    };
  });

  useEffect(() => {
    return () => {
      server.close().catch(reportError);
    };
  }, [server, reportError]);

  return server;
}
